import {CarInfoInputModel} from "@/model/car-info/car-info-input.model";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";
import router from "@/router";

export class CarInfoInputUtils {

    /**
     * メーカーパネルに表示するメーカー情報のリストを取得します。
     */
    public static async getMakers() {
        try {
            const response = await axios.get("/car-matching/makers")
            return response.data.map(maker => (
                {
                    id: maker.id,
                    name: maker.brandName,
                    logoUrl: maker.image,
                    isDomestic: maker.productionType === "1"
                }
            ))
        } catch (error) {
            AxiosUtils.gotoClientErrorPage(error, router)
        }
    }

    /**
     * メーカーIDに対応する車種の頭文字のリストを返します。
     * @param makerId メーカーID ※メーカーで絞り込む場合、nullを指定すると全ての頭文字が取得
     */
    public static async getCarTypes(makerId: number) {
        try {
            const response = await axios.get(`/car-matching/types/${makerId}`)
            return response.data.map(type => {
                const initial = type.carTypeIndex + (type.carTypeIndex.length == 1 ? "行" : "") // 「ア」なら末尾に「行」を追加、「ア行」「英数」はそのまま
                return {
                    id: type.id,
                    name: type.carTypeName,
                    initial: initial
                }
            })
        } catch (error) {
            AxiosUtils.gotoClientErrorPage(error, router)
        }
    }

    /**
     * 車種IDに対応する車種詳細情報を取得します。
     * @param carTypeId 車種詳細ID
     */
    public static async getCarTypeDetails(carTypeId: number) {
        try {
            const response = await axios.get(`/car-matching/details/${carTypeId}`);
            return response.data.map(d => {
                // XLとRFTを文字列のtrue/falseに設定しなおす
                d.xl = d.xl === 'XL' ? 'true' : 'false';
                d.rft = d.rft === 'RFT' ? 'true' : 'false';
                return d;
            });
        } catch (error) {
            AxiosUtils.gotoClientErrorPage(error, router);
        }
    }

    /**
     * 年式のラベルを取得します。
     * @param modelYear 年式
     * @param modelFinalYear 終売年
     */
    public static formatModelYear({modelYear, modelFinalYear}): string {
        let result = modelYear + "年〜"
        if (modelFinalYear) {
            result += modelFinalYear + "年"
        }
        return result
    }

    /**
     * グレード・型式・駆動式のラベルを取得します。(グレード/記号-型式(駆動式))
     * @param grade グレード
     * @param modelSymbol 記号
     * @param model 型式
     * @param driveSystem 駆動式
     */
    public static formatGradeModelsLabel(grade: string, modelSymbol: string, model: string, driveSystem: string): string {
        let driveSystemValue = "";
        if (driveSystem) {
            driveSystemValue = `(${driveSystem})`
        }

        return `${grade}/${modelSymbol}-${model}${driveSystemValue}`
    }

    /**
     * タイヤパネル表示ラベルを取得します。(タイヤ幅/扁平率Rリム径 XL RTF)
     * @param tireWidth タイヤ幅
     * @param aspectRatio アスペクト比
     * @param radial ラジアル
     * @param rimDiameter リム径
     * @param xl エクストラロード有無
     * @param rft ランフラットタイヤ有無
     */
    public static formatTireSize(tireWidth: string, aspectRatio: number, radial: string, rimDiameter: string, xl: string, rft: string): string {
        const xlValue = xl === "true" ? " XL" : ""
        const rftValue = rft === "true" ? " RFT" : ""
        return `${tireWidth}/${aspectRatio}${radial}${rimDiameter}${xlValue}${rftValue}`
    }

    /**
     * 選択された年式・グレード型式でフィルタされたタイヤサイズのリストを作成します
     */
    public static createFilteredTireSizeList(model: CarInfoInputModel):Array<any>{
        return model.carTypeMaster.carTypeDetails.filter(data => {
            // 年式でフィルタリング
            return model.modelYear ? model.modelYear === CarInfoInputUtils.formatModelYear(data) : true;
        }).filter(data => {
            // グレード・型式・駆動式でフィルタ
            return model.model ? model.model === CarInfoInputUtils.formatGradeModelsLabel(data.grade, data.modelSymbol, data.model, data.driveSystem) : true;
        })
    }
}